import { render, staticRenderFns } from "./Valve.vue?vue&type=template&id=fd1fcd12"
import script from "./Valve.vue?vue&type=script&lang=js"
export * from "./Valve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports